import React, {useState} from 'react';
import Form, { Actions, EmailAddressValidator, RequiredValidator, TextField } from '../../Components/Form';
import Card from '../../Components/Containers/Card';
import { Link } from 'react-router-dom';
import { useToasts } from '../../Components/Toasts';
import API from '../../Services/API';

const ForgotPassword = () => {
    const {showError} = useToasts();
    const [done, setDone] = useState(false);

    const reset = (data) => {
        setDone(false);
        return API.post('/auth/requestReset', data).then(() => {
            setDone(true);
        }).catch(err => {
            showError(API.parseErrorResponse(err));
        });
    }

    return <>
        <img src="/logo-name-horizontal.png"
            alt="getSoapy Logo"
            width="888"
            height="183"
            className="w-[75%] h-auto mx-auto mb-8"
        />

        <Card>
            {done === true && <div>
                <p><strong>Check your emails</strong></p>
                <p className="text-muted my-3">
                    We've sent you a link to let you reset your password.<br />
                    If you don't see it, check your spam folder.
                </p>
                <Link to="/login" className="link">Back to login</Link>
            </div>}

            {done === false && <Form onSubmit={reset}>
                <TextField type="email" name="email" label="Email" validators={[RequiredValidator, EmailAddressValidator]} />
                <Actions submit={{label: 'Reset password'}}
                    left={<Link to="/login" className="inline-block mt-4 text-muted">Login</Link>}
                />
            </Form>}
        </Card>

        <p className="text-center mt-4 text-muted text-sm">
            Don't have an account yet? <Link to="/register" className="link">Register for free!</Link>
        </p>
    </>;
}

export default ForgotPassword;
